import BaseSetup from '@/components/BaseSetup';
import { RouteLocationRaw } from 'vue-router';

export type SharedStatCardEmits = {};

export type SharedStatCardProps = {
	icon: string
	label: string
	count: number
	color?: Orion.Color | Orion.ColorAlt
	to?: RouteLocationRaw
};

export default class SharedStatCardSetup extends BaseSetup {

	static readonly defaultProps = { color: 'grey' as Orion.Color | Orion.ColorAlt };

	get rgbColor () { return `var(--rgb-${this.props.color})` }

	constructor (
		private props: SharedStatCardProps,
		private emits: SharedStatCardEmits,
	) {
		super();
	}

}
